module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-5-273ef67e5b081df09dd587e4a674a442.svg";